var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.items,"item-text":"name","item-value":"value"},on:{"change":_vm.change},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }